/**
 * @(#)2019/8/26.
 * YxAction，行为组件，用于处理按钮逻辑
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import "./index.less";
import React from "react";
import { Tooltip } from "antd";
import checkProps from "./check";
import YxModal from "../YxModal";
import config from "../../config";
import YxButton from "../YxButton";
import Tag from "./components/YxTag";
import Link from "./components/YxLink";
import Icon from "./components/YxIcon";
import defaulParam from "./actionParam";
import request from "../../utils/request";
import { l } from "../../config/language";
import YxPopconfirm from "../YxPopconfirm";
import { isString, cloneDeep } from "lodash";
import { YxComponent, Route, Connection } from "../YxComponent";
import {
  get,
  merge,
  strFormat,
  factory,
  getPath,
  objectF,
  yxActionProps,
} from "../../utils";
import { actionData, emumMate, typeParam, showMessage } from "./tools";
import {
  routeGoto,
  uploadFileAction,
  createUpload,
  typeList,
  parseQueryString,
} from "./tools";
import { toArray, filterObj, downFile, random, nodeFactory } from "../../utils";

@Connection(defaulParam)
@Route
class BaseAction extends YxComponent {
  constructor(props, context) {
    super(props, context, 100);
    const isConfirm = get(config, "action.isConfirm", false);
    this.state = {
      loading: false,
      popupVisible: false, //弹出窗的内容
      disabled: get(this.props, "disabled", false),
      isConfirm: get(this.props, "isConfirm", isConfirm),
    };
    this.upload = null;
    this.inputId = random();
    this.data = actionData(this.props);
    const dictClass = `yx_action_${get(this.props, "styleType", "button")}`;
    this.divClassName = ["yx_action", dictClass];
  }

  static Name = "BaseAction";

  async componentDidMount() {
    this._startQueue();
    if (get(this.props, "actionType", "action") === "upload") {
      this.upload = await createUpload(this.props);
    }
    get(this.props, "load", () => {})({
      param: this.paramSelected,
    });
    if (get(this.props, "actionType", "popup") === "popup") {
      this._clostQueue();
    }
  }

  shouldComponentUpdate() {
    return this._appendQueue();
  }

  componentWillReceiveProps(nextProps) {
    const checkData = ["data", "model", "factory"];
    const props = this.props;
    filterObj(props, nextProps, checkData, () => {
      this.data = actionData(nextProps);
      return false;
    });
    const checkStatus = ["disabled", "isConfirm"];
    const updateState = filterObj(props, nextProps, checkStatus);
    if (Object.keys(updateState).length !== 0) {
      this.setState(updateState);
    }
  }

  get loading() {
    const styleType = get(this.props, "styleType", "button");
    let loadingList = [this.state.loading, get(this.props, "loading", false)];
    if (styleType !== "button") {
      loadingList.push(this.state.disabled);
    }
    return loadingList.some((loading) => loading);
  }

  get popupParam() {
    const result = get(this.props, "popupParam", {});
    if (result instanceof Function) {
      return result(this.data);
    }
    return result;
  }

  get modalParam() {
    const param = {
      data: this.data,
      destroyOnClose: true,
      confirmLoading: this.loading,
      visible: this.state.popupVisible,
      className: "yx_action_popup_modal",
      onCancel: () => this.setState({ popupVisible: false }),
    };
    const popupParam = this.popupParam;
    const children = get(popupParam, "children", "");
    const result = merge(param, popupParam);
    result.onOk = this.modalOk;
    const extraParam = {
      closePopup: () => this.setState({ popupVisible: false }),
    };
    result.children = nodeFactory(children, this.data, extraParam);
    return result;
  }

  modalOk = async () => {
    const onOk = get(this.popupParam, "onOk", () => {});
    const status = await onOk(this.data);
    if (status !== false) {
      this.setState({ popupVisible: false });
    }
  };

  popupClick = async () => {
    const openPopupCallbak = get(this.popupParam, "openPopup", () => {});
    const status = await openPopupCallbak(this.data);
    if (status !== false) {
      this.setState({ popupVisible: true });
    }
  };

  /**
   * 当提交按钮
   *
   * @memberof YxAction
   */
  submitClick = (event) => {
    return new Promise((resolve, reject) => {
      const validateModel = get(this.props, "validateModel", "defaul");
      const validateOptions = get(this.props, "validateOptions", undefined);
      const ids = get(this.props, "ids", undefined);
      const dict = {
        scroll: "validateFieldsAndScroll",
        defaul: "validateFields",
      };
      let validate = () => {};
      if (validateOptions == null) {
        validate = get(this.props, `form.${dict[validateModel]}`, () => {});
      } else {
        validate = get(
          this.props,
          validateOptions,
          `form.${dict[validateModel]}`,
          () => {}
        );
      }
      validate(ids, async (err, values) => {
        if (err != null) return;
        const callback = get(this.props, "validateCallback", null);
        const requestParam = cloneDeep(get(this.props, "requestParam", null));
        if (requestParam) {
          const param = { data: values };
          this.setState({ loading: true });
          await request(merge(param, requestParam)).catch(reject);
          this.setState({ loading: false });
        } else {
          callback instanceof Function
            ? callback(ids, values, this.data)
            : null;
        }
        resolve();
      });
    });
  };

  backClick = () => {
    const path = get(this.props, "path", null);
    if (path == null) {
      this.route.goBack();
    } else {
      const data = this.data;
      const url = strFormat(path, data);
      this.route.push(url);
    }
  };

  actionClick = async (...args) => {
    const requestParam = get(this.props, "requestParam", null);
    const click = get(this.props, "onClick", null);
    if (click) {
      click(...args);
    } else if (requestParam != null) {
      this.setState({ loading: true });
      let result = await request(merge({ data: this.data }, requestParam));
      this.setState({ loading: false });
      return result;
    }
  };

  resetClick = async () => {
    const ids = get(this.props, "ids", undefined);
    const resetFields = get(this.props, "form.resetFields", () => {});
    await resetFields(ids);
  };

  jumpClick = () => {
    if (get(this.props, "href", null) != null) return;
    const path = get(this.props, "path", null);
    const jumpType = get(this, "props.jumpType", "router"); //跳转类型
    const data = this.data;
    let url = path instanceof Function ? path(data) : strFormat(path, data);
    const queryModel = get(this.props, "queryModel", null);
    const queryFactory = get(this.props, "queryFactory", null);
    if (queryFactory || queryModel) {
      let urlParam = factory(data, queryModel, queryFactory);
      url = getPath(url, urlParam);
    }
    this.jumpRun(jumpType, url);
  };

  jumpRun = (type, path) => {
    if (!path) return false;
    switch (type) {
      case "iframe":
        this.jumpIframe(path);
        break;
      case "blank":
        window.open(path);
        break;
      case "router":
        this.route.push(path);
        break;
      default:
        break;
    }
  };
  jumpIframe = (path) => {
    const param = parseQueryString(path);
    console.log("数据格式", param);
    this.route.push(
      `${get(
        config,
        "embeddedRender.url",
        "/"
      )}?embeddedJson=${encodeURIComponent(JSON.stringify(param))}`
    );
  };

  downFileClick = async () => {
    const requestParam = get(this.props, "requestParam", null);
    const click = get(this.props, "onClick", null);
    let url = get(this.props, "url", null);
    const downConfig = get(this.props, "downConfig", {});
    if (click) {
      click(...args);
    } else if (requestParam != null) {
      this.setState({ loading: true });
      const mergeParam = merge({ data: this.data }, requestParam);
      let result = await request(mergeParam);
      url = get(result, ["data.url", "data"], null);
    }
    const result = await downFile({ url, ...downConfig });
    return result;
  };

  uploadClick = async () => {
    const requestParam = get(this.props, "requestParam", null);
    let fileUrl = null;
    let result = null;
    const click = get(this.props, "onClick", null);
    if (click) {
      click(...args);
    } else {
      const uploadConfig = get(this.props, ["uploadConfig", "uploadParam"], {});
      fileUrl = await uploadFileAction(
        uploadConfig,
        this.upload,
        this.openLoading
      );
    }
    if (fileUrl != null) {
      if (requestParam) {
        const mergeParam = merge(
          { data: { ...this.data, fileUrl } },
          requestParam
        );
        result = await request(mergeParam);
        return result;
      }
    } else {
      return fileUrl;
    }
  };

  closeLoading = () => {
    this.setState({ loading: false });
  };

  openLoading = () => {
    this.setState({ loading: true });
  };

  /**
   * 整体的click控制
   *
   * @memberof YxAction
   */
  clickControl = (click) => {
    return async () => {
      if (this.loading) return;
      try {
        const beforeClick = get(this.props, "beforeClick", () => {});
        const callback = get(this.props, ["onClick", "handle"], null);
        const data = get(this.props, "data", {});
        const t = this.asyncSetState(
          { loading: false },
          get(this.props, "timeOut", 60) * 1000
        );
        if ((await beforeClick(data)) !== false) {
          if (callback instanceof Function) {
            const actionList = get(this.props, "iocParam", []);
            await callback(data, ...toArray(actionList));
          } else {
            const res = await click();
            await get(this.props, "afterClick", () => {})(data);
            res && showMessage(this.props);
          }
          routeGoto(this.props, this.route, this.data);
        }
        clearTimeout(t);
      } catch (error) {
        console.error("调用失败", error);
      }
      this.closeLoading();
    };
  };

  /**
   * 参数选择器选择之后的参数
   *
   * @returns
   * @memberof YxAction
   */
  paramSelected = () => {
    const actionType = get(this.props, "actionType", "action");
    const typeDict = typeParam();
    const param = get(typeDict, actionType, {});
    if (typeList().includes(actionType)) {
      param.onClick = get(this, `${actionType}Click`, () => {});
    } else {
      const actionType = get(this.props, "actionType", "action");
      console.error(`不存在这种类型 ${actionType},组件目前只支持`, typeList());
    }
    param.children = emumMate(this.props, this.data);
    return param;
  };

  /**
   * 组件确认框参数
   *
   * @memberof YxAction
   */
  popconfirmParam = (click, children) => {
    const onConfirm = this.clickControl(click);
    const defTitps = isString(children)
      ? emumMate(this.props, this.data)
      : null;
    const message = l("YxAction.tm", this, { defTitps });
    const titps = nodeFactory(get(this.props, "titps", message), this.data);
    const popconfirmParam = objectF(
      get(this.props, "popconfirmParam", {}),
      this.data
    );
    const param = { title: titps, onConfirm, isConfirm: this.state.isConfirm };
    return merge(param, popconfirmParam);
  };

  /**
   * 决定渲染哪种类型按钮
   *
   * @param {*} param 按钮都参数配置
   * @memberof YxAction
   */
  htmlSelected(param) {
    if (this.chilldrenJsx) {
      return this.chilldrenJsx;
    }
    const { styleType } = this.props;
    const TypeNode = {
      button: [
        YxButton,
        yxActionProps(param, "packUp", "uploadConfig", "change", "handle"),
      ],
      tag: [Tag, yxActionProps(param, "packUp", "iconfont")],
      icon: [Icon, yxActionProps(param, "packUp", "change")],
      link: [Link, yxActionProps(param, "packUp", "uploadConfig", "handle")],
    };
    const [Dom, props] = TypeNode[styleType] || TypeNode.link;
    return <Dom {...props} />;
  }

  productionHtml = () => {
    const extra = merge(this.paramSelected(), this.props);
    const param = {
      ...extra,
      loading: this.loading,
      className: "yx_action_item",
    };
    const title = nodeFactory(get(this.props, "title", null), this.data);
    const click = param.onClick;
    delete param.onClick;
    delete param.title;
    const popconfirmParam = this.popconfirmParam(click, param.children);
    const html = (
      <YxPopconfirm {...popconfirmParam}>
        {this.htmlSelected(param)}
      </YxPopconfirm>
    );
    if (title == null) {
      return html;
    } else {
      return <Tooltip title={title}>{html}</Tooltip>;
    }
  };

  contentDom = () => {
    const node = nodeFactory(this.props.render);
    if (node != null) {
      return node;
    }
    return checkProps(this.props) || this.productionHtml();
  };

  render() {
    const actionType = get(this.props, "actionType", "action");
    const iocParam = this.iocParam; // 从父组件YxComponent集成得来
    return (
      <div className={this.parentClass} {...iocParam}>
        {this.contentDom()}
        {actionType === "popup" && <YxModal {...this.modalParam}></YxModal>}
      </div>
    );
  }
}

export default BaseAction;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxAction/BaseAction.js